import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <DModal
  @title={{i18n "user_status.set_custom_status"}}
  @closeModal={{@closeModal}}
  class="user-status"
>
  <:body>
    <div class="control-group">
      <UserStatusPicker @status={{this.status}} />
    </div>

    {{#unless @model.hidePauseNotifications}}
      <div class="control-group pause-notifications">
        <label class="checkbox-label">
          <Input @type="checkbox" @checked={{@model.pauseNotifications}} />
          {{i18n "user_status.pause_notifications"}}
        </label>
      </div>
    {{/unless}}

    <div class="control-group control-group-remove-status">
      <label class="control-label">
        {{i18n "user_status.remove_status"}}
      </label>

      <TimeShortcutPicker
        @timeShortcuts={{this.timeShortcuts}}
        @hiddenOptions={{this.hiddenTimeShortcutOptions}}
        @customLabels={{this.customTimeShortcutLabels}}
        @prefilledDatetime={{this.prefilledDateTime}}
        @onTimeSelected={{this.onTimeSelected}}
        @_itsatrap={{this._itsatrap}}
      />
    </div>
  </:body>

  <:footer>
    <DButton
      @label="user_status.save"
      @disabled={{this.saveDisabled}}
      @action={{this.saveAndClose}}
      class="btn-primary"
    />

    <DModalCancel @close={{@closeModal}} />

    {{#if this.showDeleteButton}}
      <DButton
        @icon="trash-alt"
        @action={{this.delete}}
        class="delete-status btn-danger"
      />
    {{/if}}
  </:footer>
</DModal>
*/
{
  "id": "lRv5K4i/",
  "block": "[[[8,[39,0],[[24,0,\"user-status\"]],[[\"@title\",\"@closeModal\"],[[28,[37,1],[\"user_status.set_custom_status\"],null],[30,1]]],[[\"body\",\"footer\"],[[[[1,\"\\n    \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n      \"],[8,[39,2],null,[[\"@status\"],[[30,0,[\"status\"]]]],null],[1,\"\\n    \"],[13],[1,\"\\n\\n\"],[41,[51,[30,2,[\"hidePauseNotifications\"]]],[[[1,\"      \"],[10,0],[14,0,\"control-group pause-notifications\"],[12],[1,\"\\n        \"],[10,\"label\"],[14,0,\"checkbox-label\"],[12],[1,\"\\n          \"],[8,[39,4],null,[[\"@type\",\"@checked\"],[\"checkbox\",[30,2,[\"pauseNotifications\"]]]],null],[1,\"\\n          \"],[1,[28,[35,1],[\"user_status.pause_notifications\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[10,0],[14,0,\"control-group control-group-remove-status\"],[12],[1,\"\\n      \"],[10,\"label\"],[14,0,\"control-label\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"user_status.remove_status\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[8,[39,5],null,[[\"@timeShortcuts\",\"@hiddenOptions\",\"@customLabels\",\"@prefilledDatetime\",\"@onTimeSelected\",\"@_itsatrap\"],[[30,0,[\"timeShortcuts\"]],[30,0,[\"hiddenTimeShortcutOptions\"]],[30,0,[\"customTimeShortcutLabels\"]],[30,0,[\"prefilledDateTime\"]],[30,0,[\"onTimeSelected\"]],[30,0,[\"_itsatrap\"]]]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]],[[[1,\"\\n    \"],[8,[39,6],[[24,0,\"btn-primary\"]],[[\"@label\",\"@disabled\",\"@action\"],[\"user_status.save\",[30,0,[\"saveDisabled\"]],[30,0,[\"saveAndClose\"]]]],null],[1,\"\\n\\n    \"],[8,[39,7],null,[[\"@close\"],[[30,1]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"showDeleteButton\"]],[[[1,\"      \"],[8,[39,6],[[24,0,\"delete-status btn-danger\"]],[[\"@icon\",\"@action\"],[\"trash-alt\",[30,0,[\"delete\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"  \"]],[]]]]]],[\"@closeModal\",\"@model\"],false,[\"d-modal\",\"i18n\",\"user-status-picker\",\"unless\",\"input\",\"time-shortcut-picker\",\"d-button\",\"d-modal-cancel\",\"if\"]]",
  "moduleName": "discourse/components/modal/user-status.hbs",
  "isStrictMode": false
});